import React, {useState, lazy} from 'react';
import ApiLoad from './resources/ApiLoad';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.scss';
import DenseAppBar from './components/DenseAppBar';
import SwitchLazyPanel from './components/SwitchLazyPanel';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import DeviceHubIcon from '@mui/icons-material/DeviceHub';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import HelpIcon from '@mui/icons-material/Help';
import DialogConfirm from './components/DialogConfirm';
import TerminalIcon from '@mui/icons-material/Terminal';

const defaultModule = 'login';
const color = process.env.REACT_APP_COLOR;
const url_api = process.env.REACT_APP_URL_API;

function App() {

    const [selKeyRef, setSelKeyRef] = useState(defaultModule);
    const [token, setToken] = useState(getWithExpiry('token'));
    const [keyIo, setKeyIo] = useState(getWithExpiry('keyIo'));
    const [auth, setAuth] = useState(getWithExpiry('token') ? true : false);
    const [open, setOpen] = useState(false);
    
    const changeAuth = (auth, token, keyIo) => {

        setToken(token);
        setAuth(auth);
        setKeyIo(keyIo);

        if (auth) {
            setSelKeyRef('devices');
        }
        else{
            setSelKeyRef('login');
        }
    }

    React.useEffect(() =>{
        if (token) {
            changeAuth(auth, token, keyIo);
        }        
    },[auth, token, keyIo]);

    function getWithExpiry(key) {
        const itemStr = localStorage.getItem(key)
        if (!itemStr) {
            return null
        }

        const item = JSON.parse(itemStr)
        const now = new Date()

        if (now.getTime() > item.expiry) {
            localStorage.removeItem(key)
            return null
        }
        return item.value
    }

    const clearToken = () => {

        localStorage.removeItem("token");
        localStorage.removeItem("keyIo");
        changeAuth(false, null, null);

    }

    const resetToken = () => {
        
        ApiLoad.requestWithBearer(url_api + '/auth/logout', 'get', {}, token).then((data) => {
            clearToken()
        })
        .catch((error) => {
            if (error.status === 401){
                clearToken();
            }
            else if (error.status === 403){
                clearToken();
            }
            //console.log(error)
            //showError(error);
        });

    }

    const getItems = () =>{

        return [
            {
                label: 'Login'
                ,keyRef: 'login'
                ,icon: <VpnKeyIcon/>
                ,lazyModule: lazy(() => import(/* webpackChunkName: "Login" */'./modulos/Login'))
                ,overflowY: 'hidden'
                ,height: '100vh'
                ,options:{
                    optionsButton:{
                        disabled: token ? true : false
                        ,hidden: false
                    }
                    ,url_api
                    ,changeAuth
                }
            }
            ,{
                label: 'Devices'
                ,keyRef: 'devices'
                ,icon: <DeviceHubIcon/>
                ,lazyModule: lazy(() => import(/* webpackChunkName: "Devices" */'./modulos/Devices'))
                ,options:{
                    optionsButton:{
                        disabled: token ? false : true
                        ,hidden: false
                    }
                    ,token
                    ,url_api
                    ,resetToken
                    ,keyIo
                }
            }
            ,{
                label: 'Programs'
                ,keyRef: 'programs'
                ,icon: <TerminalIcon/>
                ,lazyModule: lazy(() => import(/* webpackChunkName: "Programs" */'./modulos/Programs'))
                ,options:{
                    optionsButton:{
                        disabled: token ? false : true
                        ,hidden: false
                    }
                    ,token
                    ,url_api
                    ,resetToken
                    ,keyIo
                }
            }
            ,{
                label: 'Cerrar Sesión'
                ,keyRef: 'logout'
                ,icon: <ExitToAppIcon/>
                ,lazyModule: null
                ,options:{
                    optionsButton:{
                        disabled: token ? false : true
                        ,hidden: false
                    }
                    ,resetToken
                }
            }
            ,{
                label: 'Ayuda'
                ,keyRef: 'ayuda'
                ,icon: <HelpIcon/>
                ,lazyModule: lazy(() => import(/* webpackChunkName: "Help" */'./modulos/Help'))
                ,options:{
                    optionsButton:{
                        disabled: false
                        ,hidden: false
                    }
                }
            }
        ]
    }
    
    const onClick = (newKeyRef, options) => {
        switch(newKeyRef){
            case 'logout':
                setOpen(true);
                return false;
            default:
                setSelKeyRef(newKeyRef);
                return true;
        }
    }

    const onConfirm = () => {
        resetToken()
        setOpen(false)
    }

    return (       
        <div style={{
                margin: '0'
                ,backgroundColor: 'inherit'
                ,minHeight: '100%'
                ,verticalAlign: '100vh'
                ,width: '100vw'
            }}>
            <DialogConfirm 
                open={open} 
                onConfirm={onConfirm} 
                onCancel={() => setOpen(false)}
                textDialog="Confirme que desea cerrar la sesión"
            />
            <DenseAppBar itemsButtons={getItems()} onIconClick={onClick} defaultKeyRef={selKeyRef} titleColor={color}/>
            <SwitchLazyPanel itemsPanels={getItems()} selKeyRef={selKeyRef} color={color}/>
        </div>
    );
}

export default App;
